<template>
  <footer class="footer-modern">
    <v-container>
      <v-row class="pb-8">
        <!-- Logo and Description -->
        <v-col cols="12" md="4" class="mb-8 mb-md-0">
          <div class="footer-logo mb-4">
            <span class="footer-badge">
              <img src="@/assets/petgroomoz.png" alt="" />
            </span>
            <div class="footer-logo-text">
              <div class="footer-name"><span class="pet">Pet</span><span class="groomoz">Groomoz</span></div>
              <div class="footer-tagline">GROOMING MADE SIMPLE</div>
            </div>
          </div>
          <p class="footer-description">
            The all-in-one platform for grooming salons, mobile groomers, and pet spas —
            bookings, pet profiles, invoices, and client messaging under your own brand.
          </p>
        </v-col>

        <!-- Company -->
        <v-col cols="12" sm="4" md="2" class="mb-8 mb-md-0">
          <h4 class="footer-heading mb-4">Company</h4>
          <ul class="footer-links">
            <li><router-link to="/why">Why PetGroomoz</router-link></li>
            <li><router-link to="/features">Features</router-link></li>
            <li><router-link to="/about">About Us</router-link></li>
            <li><router-link to="/blog">Blog</router-link></li>
            <li><router-link to="/tribzz">Tribzz for Groomers</router-link></li>
          </ul>
        </v-col>

        <!-- Support -->
        <v-col cols="12" sm="4" md="2" class="mb-8 mb-md-0">
          <h4 class="footer-heading mb-4">Support</h4>
          <ul class="footer-links">
            <li><router-link to="/documentation">Documentation</router-link></li>
            <li><router-link to="/help">Help Center</router-link></li>
            <li><router-link to="/contact">Contact Us</router-link></li>
            <li><router-link to="/demo">Request Demo</router-link></li>
            <li><router-link to="/login">Client Portal</router-link></li>
          </ul>
        </v-col>

        <!-- Legal -->
        <v-col cols="12" sm="4" md="2" class="mb-8 mb-md-0">
          <h4 class="footer-heading mb-4">Legal</h4>
          <ul class="footer-links">
            <li><router-link to="/privacy">Privacy Policy</router-link></li>
            <li><router-link to="/terms">Terms of Service</router-link></li>
            <li><router-link to="/cookies">Cookie Policy</router-link></li>
            <li><router-link to="/security">Security</router-link></li>
          </ul>
        </v-col>

        <!-- Contact -->
        <v-col cols="12" sm="6" md="2">
          <h4 class="footer-heading mb-4">Contact</h4>
          <div class="footer-contact">
            <div class="contact-item mb-2">
              <v-icon small color="#F4A259" class="mr-2">mdi-email</v-icon>
              <a href="mailto:ricosevere@codeforgedev.com">ricosevere@codeforgedev.com</a>
            </div>
            <div class="contact-item mb-2">
              <v-icon small color="#F4A259" class="mr-2">mdi-phone</v-icon>
              <a href="tel:3392418725">(339) 241-8725</a>
            </div>
            <div class="contact-item">
              <v-icon small color="#F4A259" class="mr-2">mdi-map-marker</v-icon>
              <span>United States</span>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-divider class="mb-6 footer-divider"></v-divider>

      <div class="footer-bottom">
        <p class="copyright mb-0">© {{ currentYear }} PetGroomoz. All rights reserved.</p>
        <div class="footer-meta">
          <span class="meta-item">Made in USA</span>
          <span class="meta-divider">•</span>
          <span class="meta-item">Built for Groomers</span>
        </div>
      </div>
    </v-container>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600;700;800&display=swap');

.footer-modern {
  --apricot: #F4A259;
  --apricot-light: #F7C28F;
  --text-primary: #F7F0E6;
  --text-secondary: rgba(247, 240, 230, 0.7);
  --text-muted: rgba(247, 240, 230, 0.5);
  --border-subtle: rgba(247, 240, 230, 0.08);

  background: #081619;
  border-top: 1px solid var(--border-subtle);
  color: var(--text-secondary);
  padding: 64px 0 24px;
  font-family: 'Figtree', -apple-system, BlinkMacSystemFont, sans-serif;
}

.footer-logo { display: flex; align-items: center; gap: 12px; }

.footer-badge {
  width: 46px; height: 46px; flex-shrink: 0;
  border-radius: 50%;
  background: #F7F0E6;
  overflow: hidden;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 0 0 3px rgba(244, 162, 89, 0.2);
}
.footer-badge img { width: 100%; height: 100%; object-fit: cover; }

.footer-logo-text { display: flex; flex-direction: column; line-height: 1.15; }
.footer-name { font-size: 1.35rem; font-weight: 800; letter-spacing: -0.01em; }
.pet { color: #6BD6C4; }
.groomoz { color: #F4A259; }
.footer-tagline { font-size: 0.62rem; font-weight: 700; letter-spacing: 2.2px; color: var(--text-muted); margin-top: 3px; }

.footer-description { font-size: 0.92rem; line-height: 1.7; color: var(--text-muted); max-width: 340px; }

.footer-heading { font-size: 0.95rem; font-weight: 700; color: var(--text-primary); }

.footer-links { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 10px; }

.footer-links a {
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.92rem;
  transition: all 0.25s ease;
  display: inline-block;
}
.footer-links a:hover { color: var(--apricot-light); transform: translateX(4px); }
.footer-links a:focus-visible { outline: 2px solid var(--apricot); outline-offset: 3px; border-radius: 4px; }

.footer-contact { font-size: 0.9rem; }
.contact-item { display: flex; align-items: center; }
.contact-item a { color: var(--text-secondary); text-decoration: none; word-break: break-all; }
.contact-item a:hover { color: var(--apricot-light); }
.meta-divider { opacity: 0.5; }

.footer-divider { border-color: var(--border-subtle) !important; }

.footer-bottom { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; }
.copyright { font-size: 0.85rem; color: var(--text-muted); }
.footer-meta { display: flex; align-items: center; gap: 10px; font-size: 0.85rem; color: var(--text-muted); }
.meta-item { font-weight: 600; }

@media (max-width: 600px) {
  .footer-bottom { flex-direction: column; align-items: flex-start; }
}
</style>